<template>
	<TeamingDropDown
		:class-name="className"
		:disabled="disabled"
		:options="options"
		:value="value"
		:width="width"
		@change="onChange"
	>
		<template v-slot:selected="{ selectedOption, onSelectorClicked }">
			<div class="confidence-level-menu__chip-selector">
				<ConfidenceChip
					:level="selectedOption.value"
					@click="onSelectorClicked"
				/>
			</div>
		</template>
		<template v-slot:options="{ option, onOptionClicked }">
			<div @click="onOptionClicked(option, $event)">
				<ConfidenceChip
					class-name="confidence-level-menu_selected-chip"
					:disabled="disabled"
					:level="option.value"
					@click="onOptionClicked(option, $event)"
				/>
			</div>
		</template>
	</TeamingDropDown>
</template>

<script>
import { ConfidenceLevel } from "@teaming/common-enums";
import ConfidenceChip from "./ConfidenceChip";
import TeamingDropDown from "./TeamingDropDown";

export default {
	name: "ConfidenceLevelMenu",

	emits: [ "change", ],

	props: {
		className: {
			type: String,
			default: "",
		},
		value: {
			type: String,
			default: ConfidenceLevel.HIGH,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: "",
		},
	},

	components: {
		ConfidenceChip,
		TeamingDropDown,
	},

	computed: {
		options() {
			return [
				{
					text: "High",
					value: ConfidenceLevel.HIGH,
				},
				{
					text: "Medium",
					value: ConfidenceLevel.MEDIUM,
				},
				{
					text: "Low",
					value: ConfidenceLevel.LOW,
				},
			];
		},
	},

	methods: {
		onChange( option ) {
			this.$emit( "change", option );
		},
	},
};
</script>

<style lang="scss" scoped>
.confidence-level-menu__chip-selector {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
}

.confidence-level-menu_selected-chip {
	z-index: 10;
	&.teaming-chip {
		display: inline-flex;
	}
}

.confidence-level-menu__menu-option {
	padding: 0.5rem;
}
</style>
